import React, { useEffect, useState } from 'react'
import TableWrapper from '../../../../component/TableWrapper';
import { Icons, Images } from '../../../../assets';
import { useNavigate } from 'react-router-dom';
import request from "../../../../service/index";
import Exported from '../../../../service/endpoints';
import { Toast } from '../../../../service/toast';
import GetUserPermission from '../../../../component/GetUserPermission';
import { BULK_FILTRATION, Filters, TRUCK_SOLUTIONS } from '../../../../helpers';
import NormalSelect from '../../../../component/NormalSelect';
import { saveLoadingState } from '../../../../redux/reducers/loadingSlice';
import { useDispatch } from 'react-redux';

const ProductList = ({ getTab, searchInput }) => {

    const dispatch = useDispatch()
    const [page, setPage] = useState(1);
    const [productList, setProductList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState(null);
    const currentTab = getTab
    const navigate = useNavigate()
    const viewPermission = GetUserPermission({ key: 'view' });
    const deletePermission = GetUserPermission({ key: 'delete' });
    const editPermission = GetUserPermission({ key: 'edit' });
    const ACTIVE = 'Active'
    const IN_ACTIVE = 'Inactive'
    const dropdownList = [
        { label: ACTIVE, value: [ACTIVE] },
        { label: IN_ACTIVE, value: [IN_ACTIVE] },
    ]
    const userTrcuckHeader = [
        { label: 'KG Reference Number', sortable: 'productId' },
        { label: 'Product Image' },
        { label: 'Status' },
        { label: 'Actions' },
    ];

    const userFilterHeader = [
        { label: 'KG Reference Number', sortable: 'productId' },
        { label: 'Product Image' },
        { label: 'Category', sortable: 'category' },
        { label: 'Status' },
        { label: 'Actions' },
    ];

    const bulkFiltrationHeader = [
        { label: 'KG Reference Number' },
        { label: 'KG Reference Name' },
        { label: 'Product Image' },
        { label: 'Status' },
        { label: 'Actions' },
    ];

    const handleData = (keyValue, defaultValue, className = '') => {
        return (
            <td className={`${className}`}>{keyValue ? keyValue : defaultValue}</td>
        )
    };

    const redirectTo = (index) => {
        navigate(`?category=${currentTab}?id=${index}`)
    }

    const redirectToEdit = (id) => {
        navigate(`?category=${currentTab}?type=edit&refId=${id}`)
    }

    const getFiltersList = async () => {
        setisLoading(true)
        let url = Exported.Endpoints.getFilter
        let paramsObj = {
            page: page,
            limit: 10,
        }

        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }

        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                console.log(res)
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setProductList(obj)
                setisLoading(false)
            }
        }).catch((err) => {
            console.log(err)
        })
        setisLoading(false)
    }

    const getTrucksList = async () => {
        setisLoading(true)
        let url = Exported.Endpoints.getTruckSolution
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                console.log(res)
                const obj = {
                    result: res?.data?.data?.list,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setProductList(obj)
                setisLoading(false)
            }
        }).catch((err) => {
            console.log(err)
        })
        setisLoading(false)
    }

    const getBulkFiltersList = async () => {
        setisLoading(true)
        let url = Exported.Endpoints.getBulkFilter
        let paramsObj = {
            page: page,
            limit: 10,
        }
        if (searchInput && searchInput !== '') {
            paramsObj['search'] = searchInput
        }
        await request({
            url: url,
            method: Exported.APIMethods.GET,
            params: { ...paramsObj }
        }).then((res) => {
            if (res?.data?.status) {
                console.log(res)
                const obj = {
                    result: res?.data?.data,
                    pageMeta: res?.data?.data?.pageMeta
                }
                setProductList(obj)
                setisLoading(false)
            }
        }).catch((err) => {
            console.log(err)
        })
        setisLoading(false)
    }

    const getNoData = () => {
        const obj = {
            result: [],
            pageMeta: {}
        }
        setProductList(obj)
    }

    useEffect(() => {
        if (currentTab === Filters) {
            getFiltersList()
        } else if (currentTab === TRUCK_SOLUTIONS) {
            getTrucksList()
        } else if (currentTab === BULK_FILTRATION) {
            getBulkFiltersList()
        } else {
            getNoData()
        }
    }, [page, currentTab, searchInput])

    const filterDataDelete = async (id) => {
        let url = `${Exported.Endpoints.getFilter}/${id}`
        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then((res) => {
            if (res?.data?.status) {
                getFiltersList()
                Toast({
                    type: 'success',
                    message: 'Deleted successfully!'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const truckSolutionDataDelete = async (id) => {
        let url = `${Exported.Endpoints.getTruckSolution}/${id}`
        const requestData = {
            id: id,
        }
        await request({
            url: url,
            method: Exported.APIMethods.DELETE,
            data: requestData
        }).then((res) => {
            if (res?.data?.status) {
                getTrucksList()
                Toast({
                    type: 'success',
                    message: 'Deleted successfully!'
                })
            }
        }).catch((err) => {
            console.log(err, "err")
            Toast({
                type: 'error',
                message: 'Unable to process the request!..'
            })
        })
    }

    const handleDelete = async (id) => {
        if (currentTab === Filters) {
            filterDataDelete(id)
        } else if (currentTab === TRUCK_SOLUTIONS) {
            truckSolutionDataDelete(id)
        }
    }

    const handleStatusChange = async (reference_number, value) => {
        if (!reference_number) return;
        
        const newStatus = value !== ACTIVE;  
        
        let url = `${Exported.Endpoints.activeInactive}/${reference_number}`;
        
        try {
            dispatch(saveLoadingState(true));  
            const response = await request({
                url: url,
                method: Exported.APIMethods.PUT,
                data: { is_deleted: newStatus },
                headers: {
                    "Content-Type": "application/json",
                },
            });
            
            if (response?.data?.status) {
                if (currentTab === Filters) {
                    getFiltersList();
                } else if (currentTab === TRUCK_SOLUTIONS) {
                    getTrucksList();
                } else if (currentTab === BULK_FILTRATION) {
                    getBulkFiltersList();
                }
                
                Toast({
                    type: "success",
                    message: `${response?.data?.data || "Status updated successfully!"}`,
                });
            } else {
                Toast({
                    type: "error",
                    message: "Failed to update product status.",
                });
            }
            dispatch(saveLoadingState(false));  
        } catch (err) {
            console.error("API Error:", err);
            Toast({
                type: "error",
                message: "Unable to process the request!..",
            });
            dispatch(saveLoadingState(false));  
        }
    };
    

    return (
        <>
            <div className={`eventWrapper`}>
                <div className={`mt-2 mb-5`}>
                    <TableWrapper
                        headerDetails={currentTab === Filters ? userFilterHeader : currentTab === TRUCK_SOLUTIONS ? userTrcuckHeader : currentTab === BULK_FILTRATION ? bulkFiltrationHeader : []}
                        pageMeta={productList?.pageMeta}
                        handlePageChange={setPage}
                        listLength={productList?.result || []}
                        isLoading={isLoading}
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                    >
                        {productList?.result?.map((item, index) => {
                            const { product_details = '', id = '', product = {}, name = '', reference_number_id='' } = item;

                            return (
                                <tr key={id}>
                                    {currentTab === BULK_FILTRATION ? (
                                        <>
                                            {handleData(id, '-', 'text-center')}
                                            {handleData(name, '-', 'text-center')}
                                            <td className="px-3 mx-auto text-center">
                                                <div style={{ height: '30px' }}>
                                                    <img
                                                        src={product?.images?.length > 0 ? product?.images[0] : Images.noImage}
                                                        alt={"No Img"}
                                                        className='w-[100%] h-[100%]'
                                                        style={{ objectFit: 'contain' }}
                                                    />
                                                </div>
                                            </td>
                                        </>
                                    ) : (
                                        <>
                                            {handleData(product_details?.reference_number, '-', 'text-center')}
                                            <td className="px-3 mx-auto text-center">
                                                <div style={{ height: '30px' }}>
                                                    <img
                                                        src={product_details?.images?.length > 0 ? product_details?.images[0] : Images.noImage}
                                                        alt={"No Img"}
                                                        className='w-[100%] h-[100%]'
                                                        style={{ objectFit: 'contain' }}
                                                    />
                                                </div>
                                            </td>
                                            {currentTab === Filters && handleData(product_details?.product_sub_category?.title, '-', 'text-center')}
                                        </>
                                    )}                            
                                    <td className="px-3 mx-auto text-center w-[130px]">
                                        <NormalSelect
                                            className="w-[110px] p-0"
                                            list={dropdownList}
                                            value={!item.product_details?.is_deleted ? ACTIVE : IN_ACTIVE}  // Direct ternary based on is_deleted
                                            handleChange={(e) => handleStatusChange(reference_number_id, e.value)}
                                            highLight
                                            highLightColor={!item.product_details?.is_deleted ? "#01CB46" : "#FC0000"}
                                            placeholder="Status"
                                        />
                                    </td>
                                    <td className="px-3 mx-auto text-center action-button">
                                        <div className='flex items-center justify-center'>
                                            <img
                                                src={Icons.eye}
                                                alt='View'
                                                className='cursor-pointer w-[20px] h-[20px] mx-2'
                                                onClick={() => redirectTo(id)}
                                            />
                                            {/* {editPermission &&
                                                <img
                                                    src={Icons.edit}
                                                    alt='Edit'
                                                    className='cursor-pointer w-[18px] h-[18px] mx-2'
                                                    onClick={() => redirectToEdit(id)}
                                                />
                                            } */}
                                            {deletePermission &&
                                                <img
                                                    src={Icons.delete}
                                                    alt='Delete'
                                                    className='cursor-pointer w-[20px] h-[20px]'
                                                    onClick={() => handleDelete(id)}
                                                />
                                            }
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}

                    </TableWrapper>
                </div>
            </div>
        </>
    )
}

export default ProductList